import React from 'react';

import Authenticated from 'Components/Layouts/Authenticated';
import PageHeader from "Components/Utilities/PageHeader";
import Section from "Components/Utilities/Section";
import QuestionSection from "Components/Utilities/QuestionSection";

import { User } from "Services";
import { asset } from "Services/BaseHelpers";
import { Link } from "react-router-dom";
import { RenderWYSIWYG } from "Components/Form";
import CmsElement from "Components/Utilities/CmsElement";
import { Loading } from "Components/Partials";
import { getRecordValue } from "Services/CmsHelpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import { Carousel } from "react-responsive-carousel";
import RegisterButton from "Components/Button/RegisterButton";
import MapButton from "Components/Button/MapButton";

export default class Hotel extends React.Component{
    /**
     * @method render
     * @return {*}
     */

    /**
     * @var state
     */
    state = {
        working: true
    };

    render () {
        const group = User.data?.groups[0]?.name ?? ' I&O - Group 1';

        return (
            <Authenticated title="Dashboard">
{/*
                {group === 'Group 2' && (<HotelGroupIO />)}
*/}
                <HotelGroupIO />
            </Authenticated>
        );
    }
}

class HotelGroupIO extends CmsElement {

    /**
     * @var cmsElementIdentifier
     */
    cmsElementIdentifier = 'hotel';

    /**
     * @var state
     */
    state = {
        working: true
    };

    /**
     * @var mapSrc
     */
    mapSrc = 'https://maps.google.com/maps?q=Kimpton%20Shinjuku,%20hotel,%20Tokyo&t=&z=13&ie=UTF8&iwloc=&output=embed';

    /**
     * @method render
     * @return {*}
     */
    render () {
        const { working, records } = this.state;
        const content = {};
        let carousel = [];
        if (records) {
            carousel = records.data
                .filter ( item => getRecordValue ( item, 'type' ).toLowerCase () === 'carousel' )
                .map ( item => getRecordValue ( item, 'image', 'file' ) );
        }
        return (
            <>
                <PageHeader
                    imgSrc={'headers/hotel.png'}
                />

                {working && (<Loading />)}

                {this.renderOpeningTextSection()}
                {this.renderMapSection()}
                {this.renderFacilitesSection()}

                <Carousel
                    showIndicators={false}
                    showThumbs={false}
                    showStatus={false}
                    renderArrowPrev={(clickHandler) => (
                        <div className="left-10 absolute inset-y-0 flex items-center z-10">
                            <FontAwesomeIcon
                                onClick={clickHandler}
                                className="text-white transition duration-200 hover:scale-110 cursor-pointer"
                                icon={faChevronLeft}
                                size="2x"
                            />
                        </div>
                    )}
                    renderArrowNext={(clickHandler) => (
                        <div className="right-10 absolute inset-y-0 flex items-center z-10">
                            <FontAwesomeIcon
                                onClick={clickHandler}
                                className="text-white transition duration-200 hover:scale-110 cursor-pointer"
                                icon={faChevronRight}
                                size="2x"
                            />
                        </div>
                    )}
                >
                    {carousel?.map((carousel, key) => (
                        <div key={`carousel-${key}`}>
                            <img src={carousel} />
                        </div>
                    ))}
                </Carousel>
            </>
        );
    }

    /**
     * @method renderOpeningTextSection
     * @return {*}
     */
    renderOpeningTextSection () {
        const { working, records } = this.state;
        const content = {};

        records && records.data.forEach(item => {
            content[getRecordValue(item, 'title')] = getRecordValue(item, 'content');
        })
        return (
            <Section>
                <div className="max-w-4xl mx-auto py-10 px-5 md:px-10">
                    <div className="flex justify-center pb-4">
                        <img
                            src={asset('images/mini-logo.png')}
                            alt="Logo"
                            className="block w-20 align-self-center"
                        />
                    </div>

                    <div className="text-center">
                        <RenderWYSIWYG
                            className="text-black"
                            content={content['Welcome Text'] ?? ''}
                        />
                    </div>
                </div>
            </Section>
        );
    }

    /**
     * @method renderMapSection
     * @return {*}
     */
    renderMapSection () {
        const { working, records } = this.state;
        const content = {};

        records && records.data.forEach(item => {
            content[getRecordValue(item, 'title')] = getRecordValue(item, 'content');
        })
        return (
            <div className="max-w-full mx-auto text-center space-y-6 my-auto">
                <div className="grid grid-cols-2 gap-0 text-white">
                    <div className="w-full bg-black bg-cover h-full">
                        <div className="my-auto flex flex-col  text-center h-full space-y-6 p-10">
                            <div className="font-bold text-2xl w-full text-white">
                                LOCATION
                            </div>

                            <RenderWYSIWYG
                                className="text-white justify-center self-center"
                                content={content['Location'] ?? ''}
                            />

                            <div className={"pt-3"}>
                                <a
                                    href={"https://www.google.com/maps/place/Kimpton+Shinjuku+Tokyo/@35.685587,139.6896764,17z/data=!3m2!4b1!5s0x60188cd2d38d813d:0x45" +
                                        "bfaeb03b3be188!4m9!3m8!1s0x60188d6357e86857:0x9828b30f6f3d39d8!5m2!4m1!1i2!8m2!3d35.6855827!4d139.6922513!16s%2Fg%2F11g3tkj1f_"}
                                    target={"_blank"} className={"pt-4"}>
                                        <MapButton text="Register Now" />
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="font-bold text-2xl my-auto mx-auto w-full">
                        <iframe
                            width="100%"
                            height="600"
                            frameBorder="0"
                            scrolling="no"
                            marginHeight="0"
                            marginWidth="0"
                            src={this.mapSrc}
                        ></iframe>
                    </div>
                </div>
            </div>
        );
    }

    /**
     * @method renderFacilitesSection
     * @return {*}
     */
    renderFacilitesSection () {
        const { working, records } = this.state;
        const content = {};

        records && records.data.forEach(item => {
            content[getRecordValue(item, 'title')] = getRecordValue(item, 'content');
        })
        return (
            <Section>
                <div>
                    <div className="text-center">
                        <RenderWYSIWYG
                            className="text-black"
                            content={content['Facilities'] ?? ''}
                        />
                    </div>
                </div>
            </Section>
        );
    }
}
